import React from "react";
import { DEADLINE_APP_ID } from "../../../config";
import PortaleChildApp from "../../portale-child-app";
import { connect } from "react-redux";

const DeadlinesView = ({ workspaceId }) => {
    return (
        <PortaleChildApp
            appId="DEADLINE"
            serviceId="rnd:comic:payments-incomes:app"
            oneFrontAppId={DEADLINE_APP_ID}
            tenantId={workspaceId}
        />
    );
};

const mapStateToProps = state => ({
    workspaceId: state.services.workspaceId.data ? state.services.workspaceId.data.id : null
});

export default connect(mapStateToProps)(DeadlinesView);
